import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App.tsx';

import '@fontsource-variable/rubik';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
